<template>
  <div>
    <Head title="Editar cliente" />
    <div class="flex justify-start mb-8 max-w-3xl">
      <h1 class="text-3xl font-bold">
        <Link class="text-indigo-400 hover:text-indigo-600" href="/clients">Clientes</Link>
        <span class="text-indigo-400 font-medium">/ Editar</span>
      </h1>
    </div>
    <div>
      <div class="form-group">
        <div class="max-w-7xl bg-white rounded-md shadow overflow-hidden">
          <form @submit.prevent="update">              
            <div class="flex flex-wrap -mb-8 -mr-6 p-8">
              <h1 class="text-3xl font-bold my-2 w-full">Datos generales</h1>
              
              <text-input v-model="form.code" :error="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/3" label="Código" readonly/>
              <text-input v-model="form.description" :error="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/3" label="Descripción" />

              <select-input v-model="form.category" :error="form.errors.category" class="pb-8 pr-6 w-full lg:w-1/3" label="Categoría">
                <option v-for="category in categories" :key="category.id" :value="category.id">{{ category.description }}</option>
              </select-input>

              <select-input v-model="form.type" :error="form.errors.type" class="pb-8 pr-6 w-full lg:w-1/3" label="Tipo">
                <option v-for="type in types" :key="type.id" :value="type.id">{{ type.description }}</option>
              </select-input>

              <text-input v-model="form.comments" :error="form.errors.comments" class="pb-8 pr-6 w-full lg:w-full" label="Comentarios" />               
              
              <h1 class="text-3xl font-bold my-2 w-full">Precios y descuentos</h1>
              <br />
              <div class="pb-8 pr-6 w-full lg:w-2/4">
                <label class="block">
                  <span class="block text-base text-slate-500">Lista de precios:</span>
                  <Multiselect
                    v-model="form.list_prices"
                    placeholder="Seleciona una o varias opciones"                      
                    :options="prices.map(price => ({ value: price.id, label: price.description }))" 
                    mode="tags"
                    :close-on-select="false"
                    :searchable="true"                                    
                  />
                </label>
              </div>
              <div class="pb-8 pr-6 w-full lg:w-2/4">
                <label class="block">
                  <span class="block text-base text-slate-500">Lista de descuentos:</span>
                  <!-- {{ form.discount }} -->
                  <Multiselect
                    v-model="form.discount"
                    placeholder="Seleciona una o varias opciones"                      
                    :options="discounts.map(discount => ({ value: discount.id, label: discount.name }))" 
                    mode="tags"
                    :close-on-select="false"
                    :searchable="true"                                    
                  />
                </label>
              </div>

              <!-- <select-input v-model="form.discount" :error="form.errors.discount" class="pb-8 pr-6 w-full lg:w-2/4" label="Descuento">
                <option disabled value="">Selecciona una opción</option>
                <option v-for="discount in discounts" :key="discount.id" :value="discount.id">{{ discount.name }}</option>
              </select-input> -->
              
              <!-- <text-input v-model="form.discount" :error="form.errors.discount" class="pb-8 pr-6 w-full lg:w-1/3" type="number" label="Descuento" /> -->
              
              <h1 class="text-3xl font-bold my-2 w-full">Dirección y contacto</h1>
              <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-2/3" label="Dirección" />
              <!-- <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/3" label="Ciudad" />
              <text-input v-model="form.cologne" :error="form.errors.cologne" class="pb-8 pr-6 w-full lg:w-1/3" label="Colonia" />
              <text-input v-model="form.zip_code" :error="form.errors.zip_code_code" class="pb-8 pr-6 w-full lg:w-1/3" label="Código postal" /> -->
              <text-input v-model="form.in_charge" :error="form.errors.in_charge" class="pb-8 pr-6 w-full lg:w-1/3" label="Encargado" />
              <text-input v-model="form.email" :error="form.errors.email" class="pb-8 pr-6 w-full lg:w-1/3" label="Email" />
              <text-input v-model="form.phone" :error="form.errors.phone" @input="handlePhoneInput" maxlength="10" class="pb-8 pr-6 w-full lg:w-1/3" type="number" label="Teléfono" />
              <text-input-upper v-model="form.rfc" :error="form.errors.rfc" class="pb-8 pr-6 w-full lg:w-1/3" label="RFC" />
              <text-input v-model="form.lat" :error="form.errors.lat" class="pb-8 pr-6 w-full lg:w-1/3" label="*Latitud" readonly />
              <text-input v-model="form.long" :error="form.errors.long" class="pb-8 pr-6 w-full lg:w-1/3" label="*Longitud" readonly />
            </div>
            <ul role="list" class="marker:text-sky-400 list-disc pl-5 ml-8 space-y-12 text-slate-500 mb-2">
              <li>*Para generar las coordenas, busque su dirección o arrastre el marcador en el mapa</li>
            </ul>
            <div>
            <div class="max-w-7xl bg-white rounded-md shadow overflow-hidden">
              <div class="flex p-8">
                <text-input v-model="addressInput" class="border border-gray-300 px-3 py-2 w-full rounded-md" placeholder="Ingresa una dirección" label="Geolozalización" />
                <button class="btn-sky mx-5 my-6" @click.prevent="searchAddress">Buscar</button>
              </div>
            </div>
            <GMapMap
              :center="center"
              :zoom="zoom"
              map-type-id="terrain"
              style="width: 100%; height: 500px"
              @click="handleClick"
            >
              <GMapMarker
                :key="'user-marker'"
                :position="userPosition"
                :draggable="false" 
                @click="center = m.position"
              />
            </GMapMap>
          </div>
            <div class="flex items-center justify-center px-4 py-4 bg-gray-50 border-t border-gray-100">
              <loading-button :loading="form.processing" class="btn-sky px-4 py-4" type="submit">Actualizar Cliente</loading-button>
            </div>
          </form>
          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextInputUpper from '@/Shared/TextInputUpper'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import Icon from '@/Shared/Icon'
import Multiselect from '@vueform/multiselect'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextInputUpper,
    Icon,
    Multiselect,
  },
  layout: Layout,
  props: {
    categories:Array,
    client: Object,
    prices: Array,
    types:Array,
    discounts:Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        code: this.client.code,
        description: this.client.description,
        category: this.client.id_client_category,
        type:this.client.id_client_type, 
        comments: this.client.comments,
        list_prices: this.client.list_prices.split(","),
        discount: this.client.discount_ids,
        address: this.client.address,
        // city: this.client.city,
        // cologne: this.client.cologne,
        // zip_code: this.client.zip_code,
        in_charge: this.client.in_charge,
        email: this.client.email,
        phone: this.client.phone,
        rfc: this.client.rfc,
        lat: this.client.lat,
        long: this.client.long,
      }), 
      center: { lat: 17.067068284470416, lng: -96.71967474789123 },
      zoom: 10,
      userPosition: { lat: parseFloat(this.client.lat), lng: parseFloat(this.client.long) },
      addressInput: '',
      value: null,
      
    }
  },
  watch: {
    'form.list_prices': function(newVal, oldVal) {
      console.log('List Prices (nuevo valor):', newVal)
    },
    'form.lat': function(newLat, oldLat) {
      console.log('Nueva latitud:', newLat)
    },
    'form.long': function(newLong, oldLong) {
      console.log('Nueva longitud:', newLong)
    },
  },
  methods: {
    update() {   
      // Ajusta la precisión de las coordenadas y conviértelas en cadenas de texto
      const latitudString = parseFloat(this.form.lat )// Ajusta la precisión según tus necesidades
      const longitudString = parseFloat(this.form.long) // Ajusta la precisión según tus necesidades

      // Crea el objeto formData con los datos del formulario, incluyendo las coordenadas ajustadas
      const formData = {
        code: this.form.code,
        description: this.form.description,
        lat: latitudString,
        long: longitudString,
        // Agrega el resto de las propiedades del formulario aquí
      }

      // Imprime los datos del formulario en la consola
      console.log('Datos completos del formulario que se enviarán al controlador:', formData)

      // Envía los datos del formulario al controlador utilizando el método PUT
      this.form.put(`/clients/${this.client.id}`, formData)
        .then(() => {
          console.log('Datos del formulario actualizados con éxito.')
        })
        .catch((error) => {
          console.error('Error al actualizar los datos del formulario:', error)
        })
    },


    searchAddress() {
    // Método para buscar la dirección en el mapa
      const geocoder = new google.maps.Geocoder()
      geocoder.geocode({ address: this.addressInput }, (results, status) => {
        if (status === 'OK' && results && results.length) {
          const { lat, lng } = results[0].geometry.location
          this.userPosition = { lat: lat(), lng: lng() }
          this.center = { lat: lat(), lng: lng() }
          this.form.lat = lat()
          this.form.long = lng()
        
          // Ajustar el zoom del mapa para que enfoque la nueva posición
          this.zoom = 15 // Puedes ajustar el valor del zoom según lo desees
        } else {
          console.error('Error al buscar la dirección:', status)
        }
      })
    },
    onMarkerDragEnd(event) {
    // Método para actualizar la posición del marcador arrastrado
      this.userPosition = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      this.form.lat = event.latLng.lat()
      this.form.long = event.latLng.lng()
    },    
    handleClick(event) {
    // Método para manejar el clic en el marcador
      this.userPosition = { lat: event.latLng.lat(), lng: event.latLng.lng() }
      this.form.lat = event.latLng.lat()
      this.form.long = event.latLng.lng()
    },
    handlePhoneInput(event) {
      // Remove any non-numeric characters
      const inputValue = event.target.value.replace(/\D/g, '');

      // Limit the input to 10 digits
      if (inputValue.length > 10) {
        event.target.value = inputValue.slice(0, 10);
      }

      // Update the v-model value
      this.form.phone = inputValue;
    },
  }, 
}
</script>
<style src="@vueform/multiselect/themes/default.css"></style>